import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../homeslider";
import PopularFlights from "../PopularFlights";

import AboutUs from "../AboutUs";
import Faqs from "../Faqs";
import Newsletter from "../Newsletter";
import PopularFlightsRoutes from "../PopularFlightsRoutes";
import FindADriverWidgit from "./Component/FindADriverWidgit";
import FindADriver from "./Component/PopularFindADriver";
import BookTickets from "../BookTickets";
import FlightDestinations from "../FlightDestinations";
import PopularAirlines from "../PopularAirlines";
import FlightsFrom from "../FlightsFrom";
import CheapFlights from "../CheapFlights";
import Badge from "../Badge";


function Movies() {
  return (
   <>
    <Helmet>     
<title>Find a Driver & Book Cheap Flights | cheapflightsprices.com</title>
<meta name="description" content="Looking for affordable flights and reliable drivers? Get the best travel deals on cheap flight tickets and professional driver services worldwide. Book now for a seamless journey! 🚖✈️"/>
<meta name="keywords" content="movie ticket booking chennai, movie ticket booking surat, movie ticket booking app, movie ticket booking ahmedabad, movie ticket booking offers, movie ticket booking delhi, movie ticket booking jaipur, movie ticket booking mumbai, movie ticket booking pune, online movie ticket booking, movies ticket booking, movie ticket online, Online Movie booking"/>
<meta property="og:title" content="Find a Driver & Book Cheap Flights | cheapflightsprices.com" />
<meta property="og:description" content="Looking for affordable flights and reliable drivers? Get the best travel deals on cheap flight tickets and professional driver services worldwide. Book now for a seamless journey! 🚖✈️" />
<meta property="og:site_name" content="Find a Driver & Book Cheap Flights | cheapflightsprices.com" />
<meta name="twitter:title" content="Find a Driver & Book Cheap Flights | cheapflightsprices.com" />
<meta name="twitter:description" content="Looking for affordable flights and reliable drivers? Get the best travel deals on cheap flight tickets and professional driver services worldwide. Book now for a seamless journey! 🚖✈️" />
<link rel="canonical" href="/find-a-driver" />
        </Helmet>

   <section id="banner_section" className="findadriverbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-1 pb-0">Movie Ticket Booking</h1>
      <h2>Cheap Flights Prices Hotel Booking Start @ $4</h2>
      <FindADriverWidgit/>
      
    </div>
  </section>
<Badge/>
    <main id="main">
    <FindADriver />
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <FlightsFrom/>
 <section id="Cheapflights" className="section-with-bg">
  <div className="container" data-aos="fade-up">
    <div className="section-header">
      <h2><strong>Find a Driver & Travel with Ease</strong></h2>
    </div>

    <div className="designcontainer">
      <p>
        Need a reliable driver for your trip? Whether you're traveling for business, leisure, or airport transfers, we connect you with professional drivers at unbeatable rates. Travel with comfort and safety while enjoying stress-free rides to your destination.
      </p>
    </div>

    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Why Choose Our Driver Services?</h1>
      <ul className="list-disc pl-6 space-y-2 text-gray-700">
        <li><strong>✔ Experienced & Verified Drivers</strong> – Trained professionals for a smooth ride.</li>
        <li><strong>✔ Affordable Prices</strong> – Get the best rates without hidden fees.</li>
        <li><strong>✔ 24/7 Availability</strong> – Book a ride anytime, anywhere.</li>
        <li><strong>✔ Flexible Booking</strong> – Choose hourly, daily, or long-distance options.</li>
        <li><strong>✔ Wide Coverage</strong> – Available in major cities and airports worldwide.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">How It Works?</h2>
      <ol className="list-decimal pl-6 space-y-2 text-gray-700">
        <li><strong>Enter Your Pickup & Drop Location</strong> – Select your destination and travel date.</li>
        <li><strong>Choose Your Ride</strong> – Pick from economy, premium, or luxury options.</li>
        <li><strong>Confirm & Pay</strong> – Secure your booking with instant confirmation.</li>
        <li><strong>Enjoy Your Trip</strong> – Sit back and relax while our driver takes you safely to your destination.</li>
      </ol>

      <h1 className="text-2xl font-bold mt-6">Cheap Flight Deals for Your Next Trip</h1>
      <p className="text-gray-700 mt-2">Looking for budget-friendly flight tickets? We bring you the best airfare deals on domestic and international flights so you can travel more and spend less.</p>

      <h2 className="text-xl font-semibold mt-4">Top Reasons to Book with Us</h2>
      <ul className="list-disc pl-6 space-y-2 text-gray-700">
        <li><strong>✈ Lowest Airfare Guaranteed</strong> – Compare & book the cheapest flights in seconds.</li>
        <li><strong>✈ Flash Sales & Discounts</strong> – Get exclusive last-minute deals.</li>
        <li><strong>✈ Flexible Date Search</strong> – Find the best fares across multiple dates.</li>
        <li><strong>✈ 24/7 Customer Support</strong> – Assistance at every step of your journey.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-4">Popular Flight Deals</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
        <div className="p-4 border rounded-lg shadow-md">
          <p><strong>📍 New York (JFK) → London (LHR)</strong> – From $499*</p>
        </div>
        <div className="p-4 border rounded-lg shadow-md">
          <p><strong>📍 Los Angeles (LAX) → Paris (CDG)</strong> – From $549*</p>
        </div>
        <div className="p-4 border rounded-lg shadow-md">
          <p><strong>📍 Chicago (ORD) → Dubai (DXB)</strong> – From $599*</p>
        </div>
        <div className="p-4 border rounded-lg shadow-md">
          <p><strong>📍 San Francisco (SFO) → Sydney (SYD)</strong> – From $699*</p>
        </div>
      </div>

      <p className="text-gray-700 mt-4">Hurry! These deals won’t last forever. Book now and save big on your next trip.</p>

      <h2 className="text-xl font-semibold mt-6">Plan Your Perfect Journey</h2>
      <p className="text-gray-700 mt-2">From affordable flights to finding a driver for local transportation, we ensure a seamless travel experience. Whether you're planning a short getaway or a long-haul adventure, we’ve got you covered with the best deals and services.</p>
    </div>
  </div>
</section>

    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default Movies;
